import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { AlertComponent } from './alert.component';

@NgModule({
  declarations: [AlertComponent],
  entryComponents: [AlertComponent],
  imports: [CommonModule, MatSnackBarModule, MatButtonModule],
  exports: [AlertComponent, MatSnackBarModule],
  providers: [
    { provide: MAT_SNACK_BAR_DATA, useValue: {} },
    { provide: MatSnackBarRef, useValue: {} },
  ],
})
export class AlertModule {}
